export default __webpack_public_path__ + "static/media/small.ac6111bd.jpg";